<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="phone-volume" />
          {{ $t('quantity') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select :model="filterFormModel" attribute="group" class="mr-1" :options="[
                    {value: 'client', text: $t('byClient')},
                    {value: 'day', text: $t('byDay')}
                    ]"></form-select>
            <client-select :model="filterFormModel" attribute="client" @input="load" :isFilter="true"
                           :place-holder="$t('selectClient') "
                           class="mr-1"></client-select>
            <time-range-picker :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="7"
                               class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
          </div>
        </div>
        <template>
          <div class="tile">
            <h5 class="mb-3">{{ $t('discountPolicy') }}:</h5>
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th class="text-center align-middle">{{ $t('quantityDiscount') }}</th>
                  <th class="text-center align-middle">{{ $t('hotlineDiscount') }}</th>
                  <th class="text-center align-middle">{{ $t('random660Discount') }}</th>
                  <th class="text-center align-middle">{{ $t('random770Discount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="text-center align-middle">&lt; 20,000</td>
                  <td class="text-center align-middle">550</td>
                  <td class="text-center align-middle">660</td>
                  <td class="text-center align-middle">770</td>
                </tr>
                <tr>
                  <td class="text-center align-middle">20,000 - 50,000</td>
                  <td class="text-center align-middle">520</td>
                  <td class="text-center align-middle">620</td>
                  <td class="text-center align-middle">720</td>
                </tr>
                <tr>
                  <td class="text-center align-middle">50,000 - 200,000</td>
                  <td class="text-center align-middle">480</td>
                  <td class="text-center align-middle">580</td>
                  <td class="text-center align-middle">680</td>
                </tr>
                <tr>
                  <td class="text-center align-middle">&gt; 200,000</td>
                  <td class="text-center align-middle">460</td>
                  <td class="text-center align-middle">560</td>
                  <td class="text-center align-middle">660</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="text-danger">
              <p>* {{ $t('note') }}:</p>
              <p>&emsp;- {{ $t('priceVAT') }};</p>
              <p>&emsp;- {{ $t('priceDiscount') }}.</p>
            </div>
          </div>
        </template>
        <template>
          <div class="tile">
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th rowspan="2"></th>
                  <th class="text-center align-middle" colspan="4">{{ $t('hotline') }}</th>
                  <th class="text-center align-middle" colspan="4">{{ $t('random660') }}</th>
                  <th class="text-center align-middle" colspan="4">{{ $t('random770') }}</th>
                  <th class="text-center align-middle" rowspan="2">{{ $t('totalAmountDiscounted') }}</th>
                  <th v-if="checkGroup" rowspan="2"></th>
                </tr>
                <tr>
                  <th class="text-center align-middle">{{ $t('callMinutes') }}</th>
                  <th class="text-center align-middle">{{ $t('callFee') }}</th>
                  <th class="text-center align-middle">{{ $t('totalFeeDiscount') }}</th>
                  <th class="text-center align-middle">{{ $t('discountAmount') }}</th>
                  <th class="text-center align-middle">{{ $t('callMinutes') }}</th>
                  <th class="text-center align-middle">{{ $t('callFee') }}</th>
                  <th class="text-center align-middle">{{ $t('totalFeeDiscount') }}</th>
                  <th class="text-center align-middle">{{ $t('discountAmount') }}</th>
                  <th class="text-center align-middle">{{ $t('callMinutes') }}</th>
                  <th class="text-center align-middle">{{ $t('callFee') }}</th>
                  <th class="text-center align-middle">{{ $t('totalFeeDiscount') }}</th>
                  <th class="text-center align-middle">{{ $t('discountAmount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ sum.hotlineCallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.hotlineCallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.hotlineTotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.hotlineDiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random660CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random660CallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.random660TotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random660DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random770CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random770CallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.random770TotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.random770DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.totalAmountDiscounted | numFormat }}</span>
                  </td>
                  <td v-if="checkGroup" class="text-center"><span class="text-blue"></span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ avg.hotlineCallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.hotlineCallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.hotlineTotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.hotlineDiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random660CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random660CallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.random660TotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random660DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random770CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random770CallFee | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.random770TotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.random770DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.totalAmountDiscounted | numFormat }}</span>
                  </td>
                  <td v-if="checkGroup" class="text-center"><span class="text-blue"></span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td class="align-middle" style="min-width: 200px"><b>{{ label(item) }}</b></td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.hotlineCallMinutes | callDuration
                    }}</span>
                  </td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.hotlineCallFee | numFormat
                    }}</span></td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.hotlineTotalFeeDiscount | numFormat }}</span>
                  </td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.hotlineDiscountAmount | numFormat
                    }}</span>
                  </td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random660CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.random660CallFee | numFormat
                    }}</span></td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random660TotalFeeDiscount | numFormat
                    }}</span></td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random660DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random770CallMinutes | callDuration }}</span>
                  </td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.random770CallFee | numFormat
                    }}</span></td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random770TotalFeeDiscount | numFormat
                    }}</span></td>
                  <td class="text-center align-middle"><span
                    class="text-blue">{{ item.random770DiscountAmount | numFormat }}</span>
                  </td>
                  <td class="text-center align-middle"><span class="text-blue">{{ item.totalAmountDiscounted | numFormat
                    }}</span>
                  </td>
                  <td v-if="checkGroup" class="text-center" style="min-width: 120px">
                    <button
                      v-if="item.label && !refundedClients.includes(item.label)"
                      :disabled="item.totalAmountDiscounted <= 0 || item.hotlineDiscountAmount < 0 || item.random660DiscountAmount < 0 || item.random770DiscountAmount < 0 || !['owner', 'account'].includes($store.state.user.role)"
                      @click="refund(item)"
                      class="btn btn-outline-danger">{{ $t('refund') }}
                    </button>
                    <div v-else class="text-success">{{ $t('isRefunded') }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from '../../components/TimeRangePicker'
import moment from 'moment'
import ClientSelect from '../../components/ClientSelect'

export default {
  components: { ClientSelect, TimeRangePicker },
  data: function() {
    return {
      filterFormModel: {
        group: 'client',
        client: null
      },
      loading: true,
      data: [],
      sum: {},
      avg: {},
      checkGroup: false,
      refundedClients: []
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show()
      this.loading = true
      this.getRefundedClients()
      this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x')
      this.$service.get('/report/quantity', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data
        this.sum = {}
        this.avg = {}
        this.data.forEach(item => {
          item.hotlineTotalFeeDiscount = this.getTotalFeeDiscount(item, 'hotline')
          item.random660TotalFeeDiscount = this.getTotalFeeDiscount(item, 'random660')
          item.random770TotalFeeDiscount = this.getTotalFeeDiscount(item, 'random770')

          item.hotlineDiscountAmount = Number(item.hotlineCallFee) - Number(item.hotlineTotalFeeDiscount)
          item.random660DiscountAmount = Number(item.random660CallFee) - Number(item.random660TotalFeeDiscount)
          item.random770DiscountAmount = Number(item.random770CallFee) - Number(item.random770TotalFeeDiscount)

          item.totalAmountDiscounted = Math.floor(item.hotlineDiscountAmount + item.random660DiscountAmount + item.random770DiscountAmount)
        })
        this.data = this.data.filter(item => item.totalAmountDiscounted > 0)
        this.data.forEach(item => {
          for (let key in item) {
            if (key !== 'label') {
              if (!this.sum[key]) {
                this.sum[key] = 0
              }
              this.sum[key] += item[key]
            }
          }
        })
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length)
        }
        this.checkGroup = this.filterFormModel.group === 'client'
      }).finally(() => {
        loader.hide()
        this.loading = false
      })
    },
    label(item) {
      if (item.label) {
        return item.label
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY')
      }
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        client: null,
        from: moment().startOf('month').toDate().getTime(),
        to: moment().endOf('month').toDate().getTime()
      }
      this.load()
    },
    getTotalFeeDiscount(item, type) {
      let tiers = [
        { minutes: 20000, price: type === 'hotline' ? 550 : type === 'random660' ? 660 : 770 },
        { minutes: 30000, price: type === 'hotline' ? 520 : type === 'random660' ? 620 : 720 },
        { minutes: 150000, price: type === 'hotline' ? 480 : type === 'random660' ? 580 : 680 },
        { minutes: Infinity, price: type === 'hotline' ? 460 : type === 'random660' ? 560 : 660 }
      ]
      let minutes = (type === 'hotline' ? item.hotlineCallMinutes : type === 'random660' ? item.random660CallMinutes : item.random770CallMinutes) / 60

      let totalBill = 0

      if (minutes <= 20000) {
        totalBill = type === 'hotline' ? item.hotlineCallFee : type === 'random660' ? item.random660CallFee : item.random770CallFee
      } else {
        // Duyệt qua từng bậc thang để tính tổng cước
        for (let i = 0; i < tiers.length; i++) {
          if (minutes > 0) {
            let currentMinutes = Math.min(minutes, tiers[i].minutes)
            totalBill += currentMinutes * tiers[i].price
            minutes -= currentMinutes
          } else {
            break
          }
        }
      }

      return totalBill
    },
    refund(item) {
      this.$swal({
        title: this.$t('refundConfirm', [item.label]),
        icon: 'warning',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show()
          let model = {
            client: item._id,
            type: 'callRefund',
            amount: item.totalAmountDiscounted,
            ref: `callRefund_${moment().month()}_${moment().year()}_${item.label}`
          }
          this.$service.post('/credit-transaction/call-refund', model).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('success'),
                text: this.$t('refunded'),
                icon: 'success',
                toast: true,
                position: 'top-right',
                timer: 5000
              })
              this.getRefundedClients()
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('refundFailed'),
                icon: 'error'
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              })
            }
          }).finally(() => {
            loader.hide()
          })
        }
      })
    },
    getRefundedClients() {
      this.$bgService.get('/report/client-call-refunded').then(res => {
        this.refundedClients = res.data
      })
    }
  },
  mounted() {
    this.load()
  },
  i18n: {
    messages: {
      en: {
        quantity: 'Quantity report',
        byDay: 'By day',
        byMonth: 'By month',
        byClient: 'By client',
        sum: 'Sum',
        avg: 'Average',
        callMinutes: 'Call minutes',
        callFee: 'Call fee',
        totalFeeDiscount: 'Total fee discount',
        discountAmount: 'Discount amount',
        hotline: 'Hotline number - internal network calling direction',
        random660: 'Random number 660đ',
        random770: 'Random number 770đ',
        totalAmountDiscounted: 'Total amount discounted',
        refund: 'Refund',
        refundConfirm: 'Are you sure you want to refund customer {0}?',
        refunded: 'Refund successful',
        refundFailed: 'Refund failed',
        quantityDiscount: 'Quantity (total minutes/month)',
        hotlineDiscount: '2-way hotline - intra-network price (price/minute)',
        random660Discount: 'Random number 660đ (price/minute)',
        random770Discount: 'Random number 770đ (price/minute)',
        discountPolicy: 'Call fee discount policy for customers based on quantity',
        note: 'Note',
        priceVAT: 'The above unit price includes VAT',
        priceDiscount: 'Discounted price is calculated by step and applies separately to each number',
        isRefunded: 'Refunded'
      },
      vi: {
        quantity: 'Báo cáo sản lượng',
        byDay: 'Theo ngày',
        byMonth: 'Theo tháng',
        byClient: 'Theo khách hàng',
        sum: 'Tổng',
        avg: 'Trung bình',
        callMinutes: 'Số phút gọi',
        callFee: 'Cước gọi',
        totalFeeDiscount: 'Tổng cước theo chiết khấu',
        discountAmount: 'Số tiền chiết khấu',
        hotline: 'Số hotline - hướng gọi nội mạng',
        random660: 'Số random 660đ',
        random770: 'Số random 770đ',
        totalAmountDiscounted: 'Tổng tiền được chiết khấu',
        refund: 'Hoàn tiền',
        refundConfirm: 'Bạn chắc chắn muốn hoàn tiền cho khách hàng {0}?',
        refunded: 'Hoàn tiền thành công',
        refundFailed: 'Hoàn tiền thất bại',
        quantityDiscount: 'Sản lượng (tổng phút/tháng)',
        hotlineDiscount: 'Số hotline 2 chiều - giá nội mạng (giá/phút)',
        random660Discount: 'Số random 660đ (giá/phút)',
        random770Discount: 'Số random 770đ (giá/phút)',
        discountPolicy: 'Chính sách chiết khấu cước gọi cho khách hàng theo sản lượng',
        note: 'Lưu ý',
        priceVAT: 'Đơn giá trên đã bao gồm VAT',
        priceDiscount: 'Đơn giá chiết khấu tính theo bậc thang và áp dụng riêng cho từng đầu số',
        isRefunded: 'Đã hoàn tiền'
      }
    }
  }
}
</script>